import {clearFilters, loadFilters, saveFilters} from "@core/utils/session/storageFilters";

export default {
    methods: {
        saveComponentFilters(key = this.$route.path, filters) {
            saveFilters(key, filters)
        },
        loadComponentFilters(key = this.$route.path) {
            return loadFilters(key)
        },
        clearComponentFilters(key = this.$route.path) {
            clearFilters(key)
        }
    }
}